import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Common/Navbar";
import Homepage from "./Screen/Homepage/Homepage";
import Footer from "./Common/Footer";




function App() {
  return (
    <>
      {/* Common Navbar */}
      <Navbar />

      {/* Page Routes */}
      <Routes>
        {/* Example Routes */}
        
      <Route path="/" element={<Homepage/>} />
     
      </Routes>
      <Footer/>
    </>
  );
}

export default App;